/* eslint-disable react/no-children-prop */
import Fundraising from "pages/Fundraising";
import Donation from "pages/Donation";
import EasyCare from "pages/EasyCare";
import Finance from "pages/NewFinance";

import CreateInvoice from "pages/Finance/Invoices/CreateInvoice/index";
import Invoices from "pages/Finance/Invoices/index";
import Payments from "pages/Finance/payments";
import PaymentRequest from "pages/Finance/payments/paymentsRequest";
import ProductDetails from "pages/Finance/productDetails";
import SubCategory from "pages/Finance/subCategory/index";
import Help from "pages/Help";
import MemberPage from "pages/Members/Member";
import MemberDetails from "pages/Members/MemberDetails";
import AddNewMember from "pages/Members/MemberDetails/AddNewMembers";
import AddDeceased from "pages/Yaherzit/NewYahrzeit";
import Dashboard from "pages/home/Dashboard";
// import AddNewFamilyMember from "pages/Members/MemberDetails/family/AddNewFamilyMember";
import ExternalLinkDonation from "pages/ExternalLinkDonation";
import DonationDetails from "pages/ExternalLinkDonation/DonationDetails/DonationDetails";
import DonationPay from "pages/ExternalLinkDonation/DonationPay/DonationPay";
import CreateNewFilter from "pages/Members/NewFilter";

import NewEvents from "pages/NewEvents";
import { Report } from "pages/Report";
import ReligiousSchools from "pages/School";

import Communication from "pages/Communication/Communication";
import Forms from "pages/Forms";
import CreateNewForm from "pages/Forms/CreateForm/CreateForm";
import FormParticipantDetails from "pages/Forms/participants/ParticipantDetails/FormParticipantDetails";
import CreateNewEvent from "pages/NewEvents/Events/CreateNewEvent";
import EventParticipantDetails from "pages/NewEvents/participants/ParticipantDetails/EventParticipantDetails";
import CreateNewClass from "pages/School/Classes/CreateNewClass";
import Participants from "pages/School/participants";
import ParticipantDetails from "pages/School/participants/ParticipantDetails/ParticipantDetails";
import FinancialSetting from "pages/SettingFinancial";
import AccountBillingTypeView from "pages/SettingFinancial/FinancialSettingPage/AccountBillingType/AccountBillingTypeView";
import AccountsReceivable from "pages/SettingFinancial/FinancialSettingPage/AccountReceivable/AccountReceivable.js";
import BankAccountsView from "pages/SettingFinancial/FinancialSettingPage/BankAccounts/BankAccountsView";
import ChargeTypesView from "pages/SettingFinancial/FinancialSettingPage/ChargeTypes/ChargeTypesView";
import LedgerAccounts from "pages/SettingFinancial/FinancialSettingPage/LedgerAccounts/LedgerAccounts";
import PaymentsTypes from "pages/SettingFinancial/FinancialSettingPage/PaymentsTypes/PaymentsTypes";
import ProviderInformation from "pages/SettingFinancial/FinancialSettingPage/ProviderInfo/ProviderInfo";
import QuickbooksInformation from "pages/SettingFinancial/FinancialSettingPage/QuickbooksInfo/QuickbooksInfo.js";
import ReversalTypes from "pages/SettingFinancial/FinancialSettingPage/ReversalTypes/ReversalTypes";
import TaxId from "pages/SettingFinancial/FinancialSettingPage/TaxId/TaxId";
import AccountTpyes from "pages/SettingFinancial/MembersSettingPage/AccountTpyes/AccountTpyes";
import SettingsPage from "pages/Settings";
import ForgetPassword from "pages/Views/forgetPassword/forgetPassword";
import Yaherzit from "pages/Yaherzit";
import React, { createContext, useContext, useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import NotAuthorized from "components/NotAuthorized";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import CreateMember from "pages/Forms/createMember/index";
import RenewalForm from "pages/Forms/renewalForm/index";
import MembershipDetails from "pages/Forms/membersDetails/memberDetails";
import CreateBulkClass from "pages/School/bulkClass/CreateBulkClass";

export const appContext = createContext();
export const HomeRouters = ({ finalFormattedDate }) => {
  const [date, setDate] = useState();
  const [typeUser, setTypeUser] = useState(false);
  useEffect(() => {
    setDate(finalFormattedDate);
  }, []);

  const _userMods = (() => { try { return JSON.parse(localStorage.getItem("authorizedModules")) || []; } catch { return []; } })();
  const _orgMods = (() => { try { return JSON.parse(localStorage.getItem("orgAuthorizedModules")) || []; } catch { return []; } })();

  // All other modules are controlled by the USER module (org must not explicitly disable)
  const _isActive = (name) => {
    if (!_userMods.length) return true; // super admin
    const u = _userMods.find((m) => m?.moduleName === name);
    if (!u) return true; // not in user list = not restricted
    return u.active !== false;
  };

  // Dashboard is opt-in: must be enabled for the ORG and explicitly enabled for the USER
  const _isDashboardActive = () => {
    const o = _orgMods.find((m) => m?.moduleName === "dashboard");
    if (!o || o.active === false) return false;
    if (!_userMods.length) return true; // super admin
    return _userMods.find((m) => m?.moduleName === "dashboard")?.active === true;
  };

  const [isDashboardActive, setIsDashboardActive] = useState(() => _isDashboardActive());
  const [isMembersActive, setIsMembersActive] = useState(() => _isActive("members"));
  const [isYahrzeitActive, setIsYahrzeitActive] = useState(() => _isActive("yahrzeit"));
  const [isSchoolActive, setIsSchoolActive] = useState(() => _isActive("school"));
  const [isDonationActive, setIsDonationActive] = useState(() => _isActive("donation"));
  const [isFinanceActive, setIsFinanceActive] = useState(() => _isActive("finance"));
  const [isReportActive, setIsReportActive] = useState(() => _isActive("report"));
  const [isPastoralActive, setIsPastoralActive] = useState(() => _isActive("pastoral"));
  const [isSettingsActive, setIsSettingsActive] = useState(() => _isActive("settings"));
  const [isFormActive, setIsFormActive] = useState(() => _isActive("forms"));
  const [isEventsActive, setIsEventsActive] = useState(() => _isActive("events"));
  const [isCommunicationActive, setIsCommunicationActive] = useState(() => _isActive("communication"));
  const [isFundraisingActive, setIsFundraisingActive] = useState(() => _isActive("finance") && _isActive("fundraising"));

  const routes = [
    {
      path: "/home",
      name: "Home",
      page: <Dashboard />,
      permissionStatus: isDashboardActive,
    },
    {
      path: "/members",
      name: "Members",
      page: <MemberPage />,
      permissionStatus: true,
    },
    {
      path: "/add-new-member",
      name: "AddNewMember",
      page: <AddNewMember />,
      permissionStatus: true,
    },
    {
      path: "/member-details/:id",
      name: "MemberDetails",
      page: <MemberDetails />,
      permissionStatus: true,
    },
    {
      path: "/member-details/:id/family-member",
      name: "MemberDetails",
      page: <MemberDetails />,
      permissionStatus: true,
    },
    {
      path: "/religious-schools",
      name: "ReligiousSchools",
      page: <ReligiousSchools />,
      permissionStatus: isSchoolActive,
    },
    {
      path: "/create-new-report/:id",
      name: "CreateNewFilter",
      page: <CreateNewFilter />,
      permissionStatus: isReportActive,
    },
    {
      path: "/create-new-filter",
      name: "CreateNewFilter",
      page: <CreateNewFilter />,
      permissionStatus: isMembersActive,
    },
    {
      path: "/create-new-class",
      name: "CreateNewClass",
      page: <CreateNewClass />,
      permissionStatus: isSchoolActive,
    },
    {
      path: "/edit-class/:id",
      name: "CreateNewClass",
      page: <CreateNewClass />,
      permissionStatus: isSchoolActive,
    },
    {
      path: "/class-participants/details/:id",
      name: "ParticipantDetails",
      page: <ParticipantDetails />,
      permissionStatus: isSchoolActive,
    },
    {
      path: "/add-deceased/:id",
      name: "AddDeceased",
      page: <AddDeceased />,
      permissionStatus: isYahrzeitActive,
    },
    {
      path: "/add-deceased",
      name: "AddDeceased",
      page: <AddDeceased />,
      permissionStatus: isYahrzeitActive,
    },
    {
      path: "/class-participants",
      name: "participants",
      page: <Participants />,
      permissionStatus: isSchoolActive,
    },

    {
      path: "/yahrzeit",
      name: "yahrzeit",
      page: <Yaherzit />,
      permissionStatus: isYahrzeitActive,
    },
    {
      path: "/donation",
      name: "donation",
      page: <Donation />,
      permissionStatus: isFinanceActive,
    },
    {
      path: "/easycare",
      name: "Easycare",
      page: <EasyCare />,
      permissionStatus: isPastoralActive,
    },
    {
      path: "/newEvents",
      name: "newEvents",
      page: <NewEvents />,
      permissionStatus: isEventsActive,
    },
    {
      path: "/create-new-event",
      name: "CreateNewEvent",
      page: <CreateNewEvent />,
      permissionStatus: isEventsActive,
    },
    {
      path: "/edit-event/:id",
      name: "CreateNewEvent",
      page: <CreateNewEvent />,
      permissionStatus: isEventsActive,
    },
    {
      path: "/event-participants/details/:id",
      name: "EventParticipantDetails",
      page: <EventParticipantDetails />,
      permissionStatus: isEventsActive,
    },
    {
      path: "/forms",
      name: "Forms",
      page: <Forms />,
      permissionStatus: isFormActive,
    },
    {
      path: "/create-new-form",
      name: "CreateNewForm",
      page: <CreateNewForm />,
      permissionStatus: isFormActive,
    },
    {
      path: "/edit-form/:id",
      name: "CreateNewForm",
      page: <CreateNewForm />,
      permissionStatus: isFormActive,
    },
    {
      path: "/form-participants/details/:id",
      name: "FormParticipantDetails",
      page: <FormParticipantDetails />,
      permissionStatus: isFormActive,
    },
    {
      path: "/help",
      name: "Help",
      page: <Help />,
      permissionStatus: false,
    },
    {
      path: "/finance",
      name: "Finances",
      page: <Finance />,
      permissionStatus: isFinanceActive,
    },
    {
      path: "/sub-category/:ledger_id",
      name: "SubCategory",
      page: <SubCategory />,
    },
    {
      path: "/product-details",
      name: "ProductDetails",
      page: <ProductDetails />,
    },
    {
      path: "/invoices",
      name: "Invoices",
      page: <Invoices />,
      permissionStatus: isFinanceActive,
    },
    {
      path: "/create-invoice",
      name: "CreateInvoice",
      page: <CreateInvoice />,
      permissionStatus: isSettingsActive,
    },
    {
      path: "/payment-request",
      name: "PaymentRequest",
      page: <PaymentRequest />,
      permissionStatus: isSettingsActive,
    },
    {
      path: "/payments",
      name: "Payments",
      page: <Payments />,
      permissionStatus: isSettingsActive,
    },
    {
      path: "404",
      page: () => null,
    },
    {
      path: "/settings",
      name: "SettingsPage",
      page: <SettingsPage />,
      permissionStatus: isSettingsActive,
    },
    {
      path: "/report",
      name: "Report",
      page: <Report />,
      permissionStatus: isReportActive,
    },
    {
      path: "/communication",
      name: "Communications",
      page: <Communication />,
      permissionStatus: isCommunicationActive,
    },
    {
      path: "/fundraising",
      name: "Fundraising",
      page: <Fundraising />,
      permissionStatus: isFundraisingActive,
    },
    {
      path: "/financial-setting",
      name: "FinancialSetting",
      page: <FinancialSetting />,
      permissionStatus: isSettingsActive,
    },
    {
      path: "/charge-types",
      page: <ChargeTypesView heading={"Charge Types"} />,
    },
    {
      path: "/create-bulk-class",
      name: "CreateBulkClass",
      page: <CreateBulkClass />,
      permissionStatus: isSchoolActive,
    },
    {
      path: "/edit-bulk-class/:id",
      name: "CreateBulkClass",
      page: <CreateBulkClass />,
      permissionStatus: isSchoolActive,
    },
    {
      path: "/create-membership-form",
      name: "CreateMember",
      page: <CreateMember />,
      permissionStatus: isFormActive,
    },
    {
      path: "/edit-membership-form/:id",
      name: "CreateMember",
      page: <CreateMember />,
      permissionStatus: isFormActive,
    },
    {
      path: "/membership/details/:id",
      name: "MembershipDetails",
      page: <MembershipDetails />,
      permissionStatus: isFormActive,
    },
    { path: "/renewal-form/:id", page: <RenewalForm /> },
  ];


  return (
    <appContext.Provider value={{ date, typeUser, setTypeUser }}>
      <Switch>
        {routes.map((route, index) =>
          route?.permissionStatus !== false ? (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              children={route.page}
            />
          ) : (
            <Route key={index} path={route.path} exact={route.exact}>
              <NotAuthorized />
            </Route>
          )
        )}
        <Redirect path="*" to={isDashboardActive ? "/home" : "/members"} />
      </Switch>
    </appContext.Provider>
  );
};
